
import { useState } from 'react';

export function useRecommendationsDrawer() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedAnswerId, setSelectedAnswerId] = useState<string | null>(null);
  const [selectedAnswer, setSelectedAnswer] = useState<any | null>(null);
  const [editingAnswerId, setEditingAnswerId] = useState<string | null>(null);

  const openDrawer = (answerId: string, answer: any) => {
    setSelectedAnswerId(answerId);
    setSelectedAnswer(answer);
    setIsOpen(true);
  };

  const closeDrawer = () => {
    setIsOpen(false);
    setSelectedAnswerId(null);
    setSelectedAnswer(null);
  };
  
  const openRecommendationsDrawer = (answerId: string) => {
    setEditingAnswerId(answerId);
  };
  
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setEditingAnswerId(null);
    }
  };

  return {
    isOpen,
    selectedAnswerId,
    selectedAnswer,
    openDrawer,
    closeDrawer,
    editingAnswerId,
    openRecommendationsDrawer,
    handleOpenChange
  };
}
